var map = {
	"./制造&商贸企业hover.png": 2823,
	"./危化运输hover.png": 6981,
	"./商砼运输hover.png": 380,
	"./家具运输hover.png": 4636,
	"./生鲜冷链hover.png": 5173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;